package team.platforma.multiplatform_material_extension.ui.buttons

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.FilledTonalButton
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonIcon
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.ui.buttons.utils.TextGravity
import team.platforma.multiplatform_material_extension.ui.buttons.utils.initButtonKeyGrabber
import team.platforma.multiplatform_material_extension.ui.core.global_style.takeFiledButtonColors
import team.platforma.multiplatform_material_extension.ui.core.global_style.takeTonalFiledButtonColors
import team.platforma.multiplatform_material_extension.util.KeyGrabber

@Composable
fun ExtraTonalButton(
    modifier: Modifier? = null,
    onClick: () -> Unit,
    enabled: Boolean = true,
    colors: ButtonColors? = null,
    buttonText: ButtonText,
    buttonIcon: ButtonIcon? = null,
    runtimeColors: ButtonColors? = null,
    keyGrabber: KeyGrabber? = null,
    onClickKey: Key? = null
) {

    var buttonEnabled by remember { mutableStateOf(true) }

    LaunchedEffect(enabled) {
        buttonEnabled = enabled
    }

    initButtonKeyGrabber(keyGrabber, onClickKey){
        if (buttonEnabled) {
            onClick()
        }
    }

    var runtimeButtonColors by remember { mutableStateOf<ButtonColors?>(null) }

    LaunchedEffect(runtimeColors) {
        runtimeButtonColors = runtimeColors
    }

    val density = LocalDensity.current

    var desiredWidth by remember { mutableStateOf(48) }

    val textMeasurer = rememberTextMeasurer()

    LaunchedEffect(buttonText) {
        val width = textMeasurer.measure(
            text = buttonText.text,
            style = buttonText.textStyle
        ).size.width + if (buttonIcon != null) buttonIcon.size.value.toInt() / 2 else 0
        desiredWidth = with(density) { width.toDp() }.value.toInt() + 60
    }

    FilledTonalButton(
        modifier = modifier?.widthIn(min = 48.dp, max = desiredWidth.dp)
            ?: Modifier.widthIn(min = 48.dp, max = desiredWidth.dp),
        onClick = { onClick() },
        enabled = buttonEnabled,
        colors = runtimeButtonColors ?: colors ?: takeTonalFiledButtonColors(),
        contentPadding = PaddingValues(0.dp)
    ) {
        Box(
            contentAlignment = when (buttonIcon?.iconGravity) {
                IconGravity.End -> {
                    if (buttonIcon.attachText) {
                        Alignment.Center
                    } else {
                        Alignment.CenterEnd
                    }
                }

                IconGravity.Start -> {
                    if (buttonIcon.attachText) {
                        Alignment.Center
                    } else {
                        Alignment.CenterStart
                    }

                }

                null -> {
                    Alignment.CenterEnd
                }
            }
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = when (buttonText.gravity) {
                    TextGravity.Start -> Alignment.Start
                    TextGravity.End -> Alignment.End
                    TextGravity.Center -> Alignment.CenterHorizontally
                }

            ) {
                Box(
                    modifier = Modifier.padding(
                        start = buttonIcon?.let { icon ->
                            when (icon.iconGravity) {
                                IconGravity.Start -> {
                                    buttonIcon.size
                                }

                                IconGravity.End -> {
                                    buttonIcon.size / 2
                                }
                            }
                        } ?: 8.dp,
                        end = buttonIcon?.let { icon ->
                            when (icon.iconGravity) {
                                IconGravity.Start -> {
                                    buttonIcon.size / 2
                                }

                                IconGravity.End -> {
                                    buttonIcon.size
                                }
                            }
                        } ?: 8.dp,
                        top = 4.dp,
                        bottom = 4.dp
                    )
                ) {
                    Text(
                        text = buttonText.text,
                        style = buttonText.textStyle
                    )
                }

            }

            buttonIcon?.let { icon ->
                Box(
                    contentAlignment = Alignment.Center,
                    modifier = Modifier.offset {
                        if (icon.attachText) {
                            IntOffset(
                                x = when (icon.iconGravity) {
                                    IconGravity.Start -> -desiredWidth
                                    IconGravity.End -> desiredWidth
                                },
                                y = 0
                            )
                        } else {
                            IntOffset(x = 0, y = 0)
                        }

                    }
                ) {
                    Icon(
                        modifier = Modifier.size(icon.size),
                        painter = icon.painter,
                        contentDescription = null
                    )
                }

            }
        }

    }
}
